import { render, staticRenderFns } from "./B-3-2-8-1__QuicktipsDetailPageEdit.vue?vue&type=template&id=033053d7&"
import script from "./B-3-2-8-1__QuicktipsDetailPageEdit.vue?vue&type=script&lang=js&"
export * from "./B-3-2-8-1__QuicktipsDetailPageEdit.vue?vue&type=script&lang=js&"
import style0 from "./B-3-2-8-1__QuicktipsDetailPageEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VIcon,VSpacer,VTextField,VTextarea})
